import { computed, makeObservable } from 'mobx';
import { MODO_PARTICIPACAO_ADVOGADO } from '../../dominio/ModoParticipacaoAdvogado';
import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

export default class FiltroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return `Advogados inscritos para preferência/sustentação oral com OAB de outra UF (≠ ${this.store.rootStore.parametroStore.ufOrgao})`;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            label: computed
        });
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    getValorOpcao(registro) {
        return !!(registro.pedidoSustentacaoOral?.pedidosDetalhados && this.#temAdvogadoDeOutraUf(registro));
    }

    #temAdvogadoDeOutraUf(registro) {
        return registro.pedidoSustentacaoOral.pedidosDetalhados.some((pedido) => {
            return pedido.advogados?.some((advogado) => {
                return !!(
                    advogado.modoParticipacao &&
                    advogado.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo &&
                    advogado.regOAB?.siglaUf &&
                    advogado.regOAB.siglaUf !== this.store.rootStore.parametroStore.ufOrgao
                );
            });
        });
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
